import { mapGetters } from 'vuex'
import { indicatorDimensionQuery,areaDimensionQueryAreaDimensionAndArea,timeDimensionQuery, areaDimensionQuerySurveyList,
  dataRefresh, dataRefreshDate,dataRefreshProgress,configQueryIsFinishAll, configDimensionFinish} from '@/api/index-statistics'
export default {
  data() {
    return {
      treeData2: [{
        id: 200,
        name: '一级 1',
        level: 1,
        children: null
      }],
      indexTreeData: [],
      areaTreeData: [],
      timeTreeData: [],
      dataSourceList: [],
      refreshDate: '',
      refreshProgress: 0,
      refreshTimer: null,
      showProgress: false,
      isConfigComplete: false,
      isDimensionComplete:false,
      refreshVersion: 0
    }
  },
  computed: {
    ...mapGetters(['indexStatInfo']),
  },
  methods: {
    // 处理树结构数据 元素添加 气泡框展示showPopOver 次末级isNextLast 末级 isLast
    formatData(data){
      if(!Array.isArray(data)) return
      data.forEach(item => {
        if(!Array.isArray(item.children)) return
        item.children.forEach(child => {
          if(Array.isArray(child.children)){
            item.isNextLast = true
            child.children.forEach(nextChild => {
              if(Array.isArray(nextChild.children)) {
                item.isNextLast = false
              }
              // 地区树 次末级需要展示编辑框
              if(item.isNextLast && this.treetype == '2') item.showPopOver = false
            })
          }else{
            item.isLast = true
          }
        })
        if(!item.children) {
          item.isLast = true
          // 指标树 末级需要展示编辑框
          if(this.treetype == '1') item.showPopOver = false
        }else{
          this.formatData(item.children)
        }
      })
      return data
    },
    // 获取指标维度列表
    async getIndexDimensionList(id) {
      await indicatorDimensionQuery({
        indicatorStatisticsId: id || this.indexStatInfo.id
      }).then(res => {
        this.indexTreeData = res.data.data
        // this.indexTreeData = this.formatData(this.indexTreeData)
      })
    },
    // 获取地区维度列表
    async getAreaDimensionList(id){
      await areaDimensionQueryAreaDimensionAndArea({
        indicatorStatisticsId: id || this.indexStatInfo.id
      }).then(res => {
        this.areaTreeData = res.data.data.areaClassifys
        const infoObj = {}
        infoObj.isSample = res.data.data.isSample
        infoObj.surveyId = res.data.data.surveyId
        infoObj.surveyName = res.data.data.surveyName || res.data.data.surveyTitle
        infoObj.questionType = res.data.data.questionType
        infoObj.questionId = res.data.data.questionId
        infoObj.questionName = res.data.data.questionName
        infoObj.groupType = res.data.data.groupType
        infoObj.sampleId = res.data.data.sampleId
        this.$store.commit('SET_INDEX_STAT_INFO',Object.assign(this.indexStatInfo || {},infoObj))
      })
    },
    // 获取时间维度列表
    async getTimeDimensionList(id) {
      await timeDimensionQuery({
        indicatorStatisticsId: id || this.indexStatInfo.id
      }).then(res => {
        this.timeTreeData = res.data.data
      })
    },
    //获取问卷列表
    async getDataSourceList(val) {
      await areaDimensionQuerySurveyList({
        isSample: val,
        surveyId: !val ? (this.indexStatInfo.isSample ? this.indexStatInfo.sampleId : this.indexStatInfo.surveyId) : ''
      }).then(res => {
        this.dataSourceList = res.data.data.surveyList
      })
    },
    //刷新数据
    refreshData(id) {
      let that = this
      dataRefresh({
        indicatorStatisticsId: id || this.indexStatInfo.id
      }).then(res => {
        if(res.data.code == 0) {
          that.showProgress = true
          that.refreshVersion = res.data.data
          this.refreshProgress = 0
          that.refreshTimer = setInterval(() => {
            that.getRefreshProgress(id)
          },1000)
        }else{

        }
        if(res.data.code != 0){
          this.$message.error(res.data.msg || '更新失败')
        }
      })
    },
    //获取更新时间
    async getRefreshDataDate(id) {
      await dataRefreshDate({
        indicatorStatisticsId: id || this.indexStatInfo.id
      }).then(res => {
        this.refreshDate = res.data.data
      })
    },
    //获取刷新进度
    getRefreshProgress(id) {
      dataRefreshProgress({
        indicatorStatisticsId: id || this.indexStatInfo.id,
        refreshVersion: this.refreshVersion
      }).then(res => {
        this.refreshProgress = res.data.data?.progress
        this.refreshVersion = res.data.data?.refreshVersion
        if(res.data.code == 0){
          if(res.data.data.isFinished){
            this.showProgress = false
            this.getRefreshDataDate(id)
            clearInterval(this.refreshTimer)
          }
        }else if(res.data.code != 0){
          this.showProgress = false
          this.getRefreshDataDate(id)
          clearInterval(this.refreshTimer)
          this.$message.error(res.data.msg||'刷新失败!')
        }
      }).catch(err => {
        this.$message.error('刷新失败!')
        clearInterval(this.refreshTimer)
      })
    },
    // 获取配置数量
    async getConfigFinshed(id) {
      await configQueryIsFinishAll({
        indicatorStatisticsId: id || this.indexStatInfo.id
      }).then(res => {
        if(res.data.code == 0) {
          this.isConfigComplete = res.data.data
        }
      }).catch(err => {
      })
    },
    // 获取维度是否配置完成
    async getDimensionFinish(){
      await configDimensionFinish({
        indicatorStatisticsId: this.indexStatInfo.id
      }).then(res=>{
        if(res.data.code == 0) {
          this.isDimensionComplete = res.data.data
        }
      })
    },
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
  }
}
